import { Form } from 'react-bootstrap';

const Unidades = props => {
  const unidades = props.getUnidades ?? [];
  const selectedUnit = unidades.some(item => item.unidade === props.userUnidade) ? props.userUnidade : '';

  return (
    <Form.Group controlId="formUnidade" className="mt-4">
      <Form.Label>*Lotação:</Form.Label>
      <Form.Select
        autoComplete="nope"
        className="border border-secondary"
        required
        name="formUnidade"
        onChange={e => props.handleUnidade(e)}
        value={selectedUnit}
      >
        <option value="" disabled>Selecione a sua lotação</option>
        {unidades.map(item => (
          <option key={item._id} value={item.unidade}>{item.unidade}</option>
        ))}
      </Form.Select>
    </Form.Group>
  );
};

export default Unidades;
